import { AccountResponseDTO } from '@/core/api/dtos/response/accounts/account'
import { Account } from '@/core/api/entities/account/account'
import { AccountOnboardingMapper } from '@/core/api/mappers/account/accountOnboardingMapper'
import { BrandIdentityMapper } from '@/core/api/mappers/brandIdentityMapper'
import { BusinessCategoryMapper } from '@/core/api/mappers/businessCategoryMapper'
import { CulturalIdentityMapper } from '@/core/api/mappers/culturalIdentityMapper'
import { GenericMapper } from '@/core/api/mappers/genericMapper'

import { BillingInfoMapper } from '@core/api/mappers/account/billingInfoMapper'
import { MRRMapper } from '@core/api/mappers/account/mrrMapper'
import { SubscriptionMapper } from '@core/api/mappers/account/subscriptionMapper'
import { InvoiceMapper } from '@core/api/mappers/invoice/invoice'
import { RoyaltyMapper } from '@core/api/mappers/misc/royaltyMapper'

export class AccountMapper {
	static toEntity(dto: AccountResponseDTO): Account {
		const dates = GenericMapper.mapDates({
			createdAt: dto.created_at,
			updatedAt: dto.updated_at,
			deletedAt: dto.deleted_at,
		})

		//const reseller = dto.reseller ? ResellerMapper.toEntity(dto.reseller) : null

		return Account.create({
			id: dto.id,
			parentId: dto.parent_id,
			billingDataId: dto.billing_data_id,
			uuid: dto.uuid,
			name: dto.name,
			publicRadios: dto.public_radios,
			country: dto.country,
			planId: dto.plan_id,
			businessCategoryId: dto.business_category_id,
			businessCategoryDescription: dto.business_category_description ?? null,
			culturalIdentityId: dto.cultural_identity_id,
			demographicAges: dto.demographic_ages,
			demographicSocioeconomics: dto.demographic_socioeconomics,
			demographicGender: dto.demographic_gender,
			flags: dto.flags,
			accountType: dto.account_type,
			multinationalBrand: dto.multinational_brand,
			totalCompanyStores: dto.total_company_stores,
			stripeCustomerId: dto.stripe_customer_id,
			acceptedGeneralTerms: dto.accepted_general_terms,
			acceptedParticularTerms: dto.accepted_particular_terms,
			trialRemainingDays: dto.trial_remaining_days,
			termsSnapshot: dto.terms_snapshot,
			canCreateTrials: dto.can_create_trials,
			features: dto.features,
			source: dto.source,
			deleted: dto.deleted ?? false,
			suspended: dto.suspended ?? false,
			test: dto.test ?? false,
			createdAt: dates.createdAt,
			updatedAt: dates.updatedAt,
			metadata: dto.metadata,
			playersNotInstalled: dto.players_not_installed,
			playersOffline: dto.players_offline,
			playersOnline: dto.players_online,
			availablePlayers: dto.available_players,
			availableBoxes: dto.available_boxes,
			status: dto.status,
			playersCount: dto.players_count ?? 0,
			onboarding: dto.onboarding
				? AccountOnboardingMapper.toEntity(dto.onboarding)
				: undefined,
			//reseller
			royalty: dto.royalty
				? RoyaltyMapper.toEntity(dto.royalty.data)
				: undefined,
			mrr: dto.mrr ? MRRMapper.toEntity(dto.mrr.data) : undefined,
			overdue: dto.overdue
				? InvoiceMapper.toEntities(dto.overdue.data)
				: undefined,
			subscriptions: dto.subscriptions
				? SubscriptionMapper.toEntities(dto.subscriptions.data)
				: undefined,
			childrenAccounts: dto.children_accounts
				? AccountMapper.toEntities(dto.children_accounts.data)
				: undefined,
			billingInfo: dto.billing_info
				? BillingInfoMapper.toEntity(dto.billing_info.data)
				: undefined,
			businessCategory: dto.business_category
				? BusinessCategoryMapper.toEntity(dto.business_category.data)
				: undefined,
			culturalIdentity: dto.cultural_identity
				? CulturalIdentityMapper.toEntity(dto.cultural_identity.data)
				: undefined,
			brandIdentities: dto.brand_identities
				? BrandIdentityMapper.toEntities(dto.brand_identities.data)
				: undefined,
		})
	}

	static toEntities(dtos: AccountResponseDTO[]): Account[] {
		return dtos.map(this.toEntity)
	}
}
